import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import MUIDataTable from "mui-datatables";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Chip from "@mui/material/Chip";
import ConfirmationDialogRaw from "../components/ConfirmationDialogRaw";
import WrongLocationIcon from "@mui/icons-material/WrongLocation";
import { 
  // features, dateStyle,
  language } from "config";
import { FirebaseContext } from "common";
import SelectDriverModal from "components/SelectDriverModal/SelectDriverModal";
import AlertDialog from "../components/AlertDialog";
import { Tooltip } from "@material-ui/core";

const BookingHistory = () => {
  const { api } = useContext(FirebaseContext);
  const { cancelBooking } = api;
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [, setRole] = useState(null);
  const [data, setData] = useState([]);
  const bookinglistdata = useSelector((state) => state.bookinglistdata);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState("");
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });

  useEffect(() => {
    if (bookinglistdata.bookings) {
      setData(bookinglistdata.bookings);
    } else {
      setData([]);
    }
  }, [bookinglistdata.bookings]);

  useEffect(() => {
    if (auth.info && auth.info.profile) {
      setRole(auth.info.profile.usertype);
    }
  }, [auth.info]);

  const onConfirmClose = (value) => {
    if (value) {
      dispatch(
        cancelBooking({
          reason: value,
          booking: selectedBooking,
        })
      );
    }
    setOpenConfirm(false);
  };

  const [driverForBooking, setDriverForBooking] = useState({
    bookings: [],
    modal: false,
  });
  //ACTIVATE THE CANCEL MODAL
  const handleDelete = () => {
    setOpenConfirm(true);
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        display: "excluded",
        disablePadding: true,
        filter: false,
        sort: false,
      },
    },
    {
      name: "tripdate",
      label: language.booking_date,
      field: "tripdate",
      options: {
        disablePadding: true,
        sort: true,
        filter: false,
      },
    },
    {
      name: "status",
      label: language.booking_status,
      field: { render: (rowData) => <span>{language[rowData.status]}</span> },
      options: {
        customBodyRender: (value) => {
          if (value === "COMPLETE")
            return <Chip label="COMPLETED" color="success" size="small" />;
          else if (value === "CANCELLED")
            return <Chip label="CANCELLED" color="error" size="small" />;
          else if (value === "NEW")
            return (
              <Chip
                label="NEW"
                variant="outlined"
                color="warning"
                size="small"
              />
            );
          else if (value === "STARTED")
            return <Chip label="STARTED" color="warning" size="small" />;
            else if (value === "PAYMENT_PENDING")
            return (
              <Chip
                label="PAYMENT PENDING"
                variant="outlined"
                color="primary"
                size="small"
              />
            );

          else if (value === "PENDING")
            return (
              <Chip
                label="PENDING"
                variant="outlined"
                color="warning"
                size="small"
              />
            );
          else if (value === "PAID")
            return <Chip label="PAID" color="success" size="small" />;
          else if (value === "REACHED")
            return <Chip label="REACHED" color="secondary" size="small" />;
          else if (value === "ARRIVED")
            return <Chip label="ARRIVED" color="secondary" size="small" />;
          else
            return (
              <Chip
                label="ACCEPTED"
                variant="outlined"
                color="secondary"
                size="small"
              />
            );
        },
        hint: "delivery status",
        disablePadding: true,
        filter: true,
        sort: false,
      },
    },
    {
      name: "driver_name",
      label: language.assign_driver,
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "trip_start_time",
      label: language.trip_start_time,
      options: {
        disablePadding: true,
        filter: true,
        sort: true,
      },
    },
    // {
    //   name: "trip_end_time",
    //   label: language.trip_end_time,
    //   options: {
    //     display: "excluded",
    //     disablePadding: true,
    //     filter: true,
    //     sort: true,
    //   },
    // },
    // {
    //   name: "total_trip_time",
    //   label: language.total_trip_time,
    //   options: {
    //     customBodyRender: (value) => {
    //       return (value / 60).toFixed(0) + "min";
    //     },
    //     display: "excluded",
    //     disablePadding: true,
    //     filter: true,
    //     sort: true,
    //   },
    // },
    // {
    //   name: "manualDispatch",
    //   label: "Add Driver",
    //   options: {
    //     hint:"if it is orange, first select the deliveries you want to assign driver and choose from the right corner. If green it is already assigned",
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value) =>
    //       !value ? (
    //         <DriveEtaIcon color="success" />
    //         //<Chip label="ASSIGNED" color="success" size="small" />
    //       ) : <DriveEtaIcon color="warning" />
    //       //<Chip label="ADDDRIVER" color="secondary" size="small" />,
    //   },
    // },
    {
      name: "pickupAddress",
      label: language.pickup_address,
      options: {
        disablePadding: true,
        filter: false,
        sort: false,
      },
    },
    {
      name: "customer_name",
      label: language.customer_name,
      options: {
        disablePadding: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "deliveryPerson",
      label: language.deliveryPerson,
      options: {
        filter: false,
        disablePadding: true,
        sort: false,
        display: false,
      },
    },
    {
      name: "deliveryPersonPhone",
      label: language.deliveryPersonPhone,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "dropAddress",
      label: language.drop_address,
      options: {
        disablePadding: true,
        filter: false,
        sort: false,
      },
    },
    {
      name: "before_vat",
      label: language.net_amount,
      options: {
        display: "excluded",
        sort: true,
        filter: false,
      },
    },
    {
      name: "vat_fees",
      label: language.vat_fare,
      options: {
        display: "excluded",
        sort: true,
        filter: false,
      },
    },
    {
      name: "driver_share",
      label: "Total",
      options: {
        sort: true,
        filter: false,
      },
    },
    // {
    //   name: "otp",
    //   label: "Proof PIN",
    //   field: "customer_paid",
    //   options: {
    //     filter: false,
    //     sort: false,
    //   },
    //},
    // {
    //   name: "pickup_image",
    //   label: language.take_pickup_image,
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value) =>
    //       !!value ? (
    //         <img alt="Pick Up" src={value} style={{ width: 150 }} />
    //       ) : null,
    //   },
    // },
    {
      name: "deliver_image",
      label: language.take_deliver_image,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) =>
          !!value ? (
            <img alt="Deliver" src={value} style={{ width: 150 }} />
          ) : null,
      },
    },
    {
      name: "status",
      label: language.cancel_booking,
      // field: { render: (rowData) => <span>{language[rowData.status]}</span> },
      options: {
        hint: "You can Cancel Delivery only while new or pending",
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          if (value === "NEW" || value === "PENDING") {
            const handleClick = () => {
              const bookingId = tableMeta.rowData?.[0];
              const booking = data.find((b) => b.id === bookingId);
              if (!booking) {
                setCommonAlert({
                  open: false,
                  msg: "Semething went wrong, please retry",
                });
              } else {
                setSelectedBooking(booking);
                handleDelete();
              }
            };
            return (
              <Chip
                size="small"
                color="error"
                label="Cancel"
                onClick={handleClick}
                onDelete={handleClick}
                deleteIcon={<WrongLocationIcon />}
              />
            );
          } else {
            return <Chip label="ONGOING" size="small" />;
          }
        },
      },
    },
  ];

  const options = {
    filter: true,
    onFilterChange: (changedColumn, filterList) => {},
    selectableRows: true,
    filterType: "dropdown",
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 200],
    expandableRows: true,
    expandableRowsOnClick: true,
    searchPlaceholder: "Search all deliveries",
    customToolbarSelect: (selectedRows, displayData) => {
      return (
        <div style={{ paddingInline: "20px" }}>
          <Tooltip title="Assign orders to drivers" >
            <Chip 
            label="ADD DRIVER TO SELECTED ORDERS"
            style={{marginRight: "1200px"}}
              onClick={() => {
                const bookings = [];
                console.log(selectedRows)
                console.log(displayData)
                selectedRows.data
                  .map((d) => d.dataIndex)
                  .forEach((index) => {
                    const id = displayData?.[index]?.data?.[0];
                    if (id) {
                      const booking = data.find((b) => b.id === id);
                      if (booking) {
                        bookings.push(booking);
                      }
                    }
                  });
                  console.log(bookings)
                setDriverForBooking({
                  bookings: bookings,
                  modal: true,
                });
              }}
              color="warning"
              aria-label="Assign Driver"
            >
              
            </Chip >
          </Tooltip>
        </div>
      );
    },
    renderExpandableRow: (rowData) => {
      return (
        <>
          <tr>
            <td colSpan={12}>
              <TableContainer component={Paper}>
                <Table style={{ minWidth: "300" }} aria-label="simple table">
                  <TableHead></TableHead>
                  <TableBody>
                    {columns.map((col, index) => {
                      return (
                        <TableRow>
                          <TableCell>
                            {col.label}: {rowData[index]}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </td>
          </tr>
        </>
      );
    },
  };

  return (
    <>
      <MUIDataTable
        title={"Current Deliveries"}
        data={data}
        columns={columns}
        options={options}
      />
      <SelectDriverModal
        visible={driverForBooking.modal}
        bookings={driverForBooking.bookings}
        onClose={() => {
          setDriverForBooking({
            booking: [],
            modal: false,
          });
        }}
      />

      <ConfirmationDialogRaw
        open={openConfirm}
        onClose={onConfirmClose}
        value={""}
      />
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </>
  );

};

export default BookingHistory;
